// import React from "react";
// import { createBrowserRouter } from "react-router-dom";
// import App from "../App";
// import Login from "../pages/Login";
// import SignUp from "../pages/SignUp";
// import ForgotPassword from "../pages/ForgotPassword";
// import ResetPassword from "../pages/ResetPassword";
// import Layout from "../components/Layout"; // Header + Sidebar + Outlet

// import Settings from "../pages/Settings";
// import UnAuthorize from "../pages/UnAuthorize";
// import NotFound from "../pages/NotFound";
// // import AllUsers from "../pages/AllUsers";
// // import UserControl from "../pages/UserControl";

// import UnderDevelopment from "../pages/UnderDevelopment";
// import Home from "../pages/Home";
// import Divisions from "../pages/Divisions";
// import Departments from "../pages/Departments";
// // import RolesAndPermissions from "../pages/RolesAndPermissions";
// import MyOrganization from "../pages/MyOrganization";
// import MyAccount from "../pages/MyAccount";
// import AcceptInvitation from "../pages/AcceptInvitation";
// import ClientVisits from "../pages/ClientVisits";
// // import ClientVisitList from "../components/ClientVisitsComponents/ClientVisitList";
// import ClientVisitForm from "../components/ClientVisitsComponents/ClientVisitForm";
// import ClientVisitDetail from "../components/ClientVisitsComponents/ClientVisitDetail";
// import StageManagement from "../pages/StageManagement";
// // import MainDashboard from "../pages/MainDashboard";
// import SalesPersonReport from "../pages/SalesPersonReport";
// import DivisionDashboard from "../components/Dashboard/DivisionDashboard";
// import AllUsers from "../pages/AllUsers";
// // import UnAuthorized from "../pages/UnAuthorize";
// import InvitationPage from "../pages/InvitationPage";
// import InviteUserForm from "../components/InvitationComponent/InviteUserForm";
// import UserFollowupReport from "../pages/Reports/UserFollowupReport";
// import ReportsPage from "../pages/ReportsPage";
// import MISReport from "../pages/Reports/MISReport";
// import ClientStageReport from "../pages/Reports/ClientStageReport";
// import OnboardingClients from "../pages/OnboardingClients";
// import ViewClientOnboarding from "../components/OnboardingComponents/ViewClientOnboarding";
// // import ClientMap from "../pages/ClientMap";
// import ClientOnboardingCalendar from "../pages/Reports/ClientOnboardingCalendar";
// import EditOnboardingClient from "../components/OnboardingComponents/EditOnboardingClient";
// import UpgradeRequired from "../helpers/UpgradeRequired";
// import ClientListing from "../pages/Sales/ClientListing";
// import DuplicateClients from "../pages/Sales/DuplicateClients";
// import CreateEditEmployeeForm from "../components/HRComponents/CreateEditEmployeeForm";
// import ViewOneEmployee from "../components/HRComponents/ViewOneEmployee";
// import RoleListPage from "../pages/Security/RoleListPage";
// import RoleAndPermissionForm from "../components/SecurityComponents/RoleAndPermissionForm";
// import SecurityUsers from "../pages/Security/SecurityUsers";
// import UserPermissionOverrideForm from "../components/SecurityComponents/UserPermissionOverrideForm";
// import EmployeeFinanceForm from "../components/HRComponents/EmployeeFinanceForm";
// import DesignationList from "../pages/HR/DesignationList";
// import SalaryGradesPage from "../pages/HR/Setting/SalaryGradesPage";
// import ShiftManagement from "../pages/HR/Setting/ShiftManagement";
// import { HolidayManagement } from "../pages/HR/Setting/HolidayManagement";
// import { LeaveTypePage } from "../pages/HR/Setting/LeaveTypePage";
// // import AttendanceDashboard from "../pages/HR/AttendanceDashboard";
// import HROverviewTabs from "../pages/HR/HROverviewTabs";
// import OpenLeads from "../pages/OpenLeads";
// import KRAReviewWorkflowManagement from "../pages/HR/Setting/KRAReviewWorkflowManagement";
// import KraPerformanceTabs from "../pages/HR/KraPerformanceTabs";
// import ReviewEvaluation from "../components/HRComponents/ReviewEvaluation";

// // import SalaryManager from "../components/salaryComponent/salaryGeneration";
// // Reports

// // import ProfileForm from "../pages/ProfilePage";

// const router = createBrowserRouter([
//   {
//     path: "/",
//     element: <App />,
//     children: [
//       {
//         index: true,
//         element: <Login />,
//       },
//       {
//         path: "/login",
//         element: <Login />,
//       },
//       {
//         path: "/accept-invitation",
//         element: <AcceptInvitation />,
//       },
//       {
//         path: "/sign-up",
//         element: <SignUp />,
//       },
//       {
//         path : "/forgot-password",
//         element : <ForgotPassword />,
//       },
//       {
//         path : "/reset-password/:token",
//         element: <ResetPassword />,
//       },
//       // un-authorize
//       { path: "un-authorized", element: <UnAuthorize /> },
//       // Catch-all route for undefined paths
//       {
//           path: "*",
//           element: <NotFound />
//       },
       
//       {
//         path: "/:portalName",
//         element: <Layout />,
//         children: [
//           /* ===========================
//             HOME
//           =========================== */

//           { path: "home", element: <Home /> },

//           // Home Settings
//           { path: "home/settings/my-organization", element: <MyOrganization /> },
//           { path: "home/settings/divisions", element: <Divisions /> },
//           { path: "home/settings/departments", element: <Departments /> },
//           { path: "home/settings/designations", element: <DesignationList /> },
//           { path: "home/settings/designations/create", element: <DesignationList /> },
//           { path: "home/settings/notifications", element: <UpgradeRequired /> },
//           { path: "home/settings/widgets", element: <UpgradeRequired /> },

//           /* ===========================
//             SALES
//           =========================== */

//           // Dashboard
//           { path: "sales", element: <UpgradeRequired /> },

//           // Clients
//           { path: "sales/clients", element: <ClientListing /> },
//           // Open Leads
//           { path: "sales/open-leads", element: <OpenLeads /> },
//           { path: "sales/leads/convert/:leadId", element: <ClientVisitForm /> },

//           // Leads
//           { path: "sales/leads", element: <ClientVisits /> },
//           { path: "sales/leads/create", element: <ClientVisitForm /> },
//           { path: "sales/leads/edit/:id", element: <ClientVisitForm /> },
//           { path: "sales/leads/view/:id", element: <ClientVisitDetail /> },

//           // Sales Orders
//           { path: "sales/sales-orders", element: <OnboardingClients /> },
//           { path: "sales/sales-orders/view/:clientId", element: <ViewClientOnboarding /> },
//           { path: "sales/sales-orders/edit/:clientId", element: <EditOnboardingClient /> },

//           // Opportunities
//           { path: "sales/opportunities/pipeline-view", element: <UpgradeRequired /> },
//           { path: "sales/opportunities/view-all", element: <UpgradeRequired /> },

//           // Quotations
//           { path: "sales/quotations", element: <UpgradeRequired /> },

//           // Sales Channels
//           { path: "sales/sales-channels", element: <UpgradeRequired /> },

//           // Delivery
//           { path: "sales/delivery-management", element: <UpgradeRequired /> },

//           // Invoices
//           { path: "sales/invoices", element: <UpgradeRequired /> },

//           // Payments
//           { path: "sales/payments", element: <UpgradeRequired /> },

//           // Sales Returns
//           { path: "sales/sales-returns", element: <UpgradeRequired /> },

//           /* ===========================
//             EXISTING SALES MODULES
//             (Keep old + add new)
//           =========================== */

//           // Reports
//           { path: "reports/sales-person/:userId", element: <SalesPersonReport /> },
//           { path: "reports/division/:divisionId", element: <DivisionDashboard /> },

//           // Sales Settings
//           { path: "sales/settings/pipeline-stages", element: <StageManagement /> },
//           { path: "sales/settings/quotation-templates", element: <UpgradeRequired /> },
//           { path: "sales/settings/tax-pricing", element: <UpgradeRequired /> },

//               /* ===========================
//             MARKETING
//           =========================== */

//           { path: "marketing", element: <UpgradeRequired /> },

//           { path: "marketing/campaigns", element: <UpgradeRequired /> },
//           { path: "marketing/promotions", element: <UpgradeRequired /> },
//           { path: "marketing/audience", element: <UpgradeRequired /> },

//           // Settings
//           { path: "marketing/settings/email-templates", element: <UpgradeRequired /> },
//           { path: "marketing/settings/integrations", element: <UpgradeRequired /> },

//           /* ===========================
//             FINANCE
//           =========================== */

//           { path: "finance", element: <UpgradeRequired /> },

//           { path: "finance/accounts", element: <UpgradeRequired /> },
//           { path: "finance/payments", element: <UpgradeRequired /> },
//           { path: "finance/expenses", element: <UpgradeRequired /> },
//           { path: "finance/taxation", element: <UpgradeRequired /> },

//           // Settings
//           { path: "finance/settings/chart-of-accounts", element: <UpgradeRequired /> },
//           { path: "finance/settings/currency-tax", element: <UpgradeRequired /> },

//           /* ===========================
//             INVENTORY
//           =========================== */

//           { path: "inventory", element: <UpgradeRequired /> },

//           { path: "inventory/stock", element: <UpgradeRequired /> },
//           { path: "inventory/purchase-orders", element: <UpgradeRequired /> },
//           { path: "inventory/suppliers", element: <UpgradeRequired /> },

//           // Settings
//           { path: "inventory/settings/warehouses", element: <UpgradeRequired /> },
//           { path: "inventory/settings/stock-alerts", element: <UpgradeRequired /> },

//           /* ===========================
//             LOGISTICS
//           =========================== */

//           { path: "logistics", element: <UpgradeRequired /> },

//           { path: "logistics/shipments", element: <UpgradeRequired /> },
//           { path: "logistics/delivery-tracking", element: <UpgradeRequired /> },
//           { path: "logistics/vendors", element: <UpgradeRequired /> },

//           // Settings
//           { path: "logistics/settings/shipping-zones", element: <UpgradeRequired /> },
//           { path: "logistics/settings/carrier-setup", element: <UpgradeRequired /> },

//           /* ===========================
//             SERVICES
//           =========================== */

//           { path: "services", element: <UpgradeRequired /> },

//           { path: "services/requests", element: <UpgradeRequired /> },
//           { path: "services/catalogue", element: <UpgradeRequired /> },

//           // Settings
//           { path: "services/settings/categories", element: <UpgradeRequired /> },
//           { path: "services/settings/sla-rules", element: <UpgradeRequired /> },

//           /* ===========================
//             HR
//           =========================== */

//           { path: "hr", element: <UpgradeRequired /> },

//           { path: "hr/employee-management", element: <AllUsers /> },
//           { path: "hr/employee-management/employee-finance/:employeeId", element: <EmployeeFinanceForm /> },
//           { path: "hr/employee-management/employee-create", element: <CreateEditEmployeeForm /> },
//           { path: "hr/employee-management/employee/edit/:employeeId", element: <CreateEditEmployeeForm /> },
//           { path: "hr/employee-management/employee-view/:employeeId", element: <ViewOneEmployee /> },
//           { path: "hr/employee-management/employee-finance/:employeeId", element: <EmployeeFinanceForm /> },
//           { path: "hr/employee-management/employee-create", element: <CreateEditEmployeeForm /> },
//           { path: "hr/employee-management/employee/edit/:employeeId", element: <CreateEditEmployeeForm /> },
//           { path: "hr/employee-management/employee-view/:employeeId", element: <ViewOneEmployee /> },

//           // Organization Structure
//           { path: "hr/divisions", element: <Divisions /> },
//           { path: "hr/departments", element: <Departments /> },

//           { path: "hr/attendance-management", element: <HROverviewTabs /> },
//           { path: "hr/leave-management", element: <UpgradeRequired /> },
//           { path: "hr/payroll-management", element: <UpgradeRequired /> },
//           { path: "hr/expense-management", element: <UpgradeRequired /> },
//           { path: "hr/training-management", element: <UpgradeRequired /> },
//           { path: "hr/document-management", element: <UpgradeRequired /> },
//           { path: "hr/performance-management", element: <KraPerformanceTabs /> },
//           { path: "hr/performance-management/reviews/evaluation/:id", element: <ReviewEvaluation /> },
//           { path: "hr/exit-management", element: <UpgradeRequired /> },

//           // Settings
//           { path: "hr/settings/shifts", element: <ShiftManagement /> },
//           { path: "hr/settings/holidays", element: <HolidayManagement /> },
//           { path: "hr/settings/leave-types", element: <LeaveTypePage /> },
//           { path: "hr/settings/kra/review/workflows", element: <KRAReviewWorkflowManagement /> },
//           { path: "hr/settings/payroll-setup", element: <SalaryGradesPage /> },
//           { path: "hr/settings/leave-policies", element: <UpgradeRequired /> },

//               /* ===========================
//             IT
//           =========================== */

//           { path: "it", element: <UpgradeRequired /> },

//           { path: "it/assets", element: <UpgradeRequired /> },
//           { path: "it/tickets", element: <UpgradeRequired /> },
//           { path: "it/access-management", element: <UpgradeRequired /> },

//           // Settings
//           { path: "it/settings/asset-categories", element: <UpgradeRequired /> },
//           { path: "it/settings/ticket-priorities", element: <UpgradeRequired /> },

//           /* ===========================
//             LEGAL
//           =========================== */

//           { path: "legal", element: <UpgradeRequired /> },

//           { path: "legal/contracts", element: <UpgradeRequired /> },
//           { path: "legal/compliance", element: <UpgradeRequired /> },

//           // Settings
//           { path: "legal/settings/contract-templates", element: <UpgradeRequired /> },

//           /* ===========================
//             SECURITY
//           =========================== */

//           { path: "security", element: <UpgradeRequired /> },

//           // Users
//           { path: "security/users", element: <SecurityUsers /> },
//           { path: "security/users/permissions/edit/:userId", element: <UserPermissionOverrideForm /> },
//           { path: "security/users", element: <SecurityUsers /> },
//           { path: "security/users/permissions/edit/:userId", element: <UserPermissionOverrideForm /> },

//           // Invitations
//           { path: "security/invitations", element: <InvitationPage /> },
//           { path: "security/invitations/invite", element: <InviteUserForm /> },

//           { path: "invitations", element: <InvitationPage /> },
//           { path: "invitations/invite", element: <InviteUserForm /> },

//           // Roles
//           { path: "security/roles-and-permissions", element: <RoleListPage /> },
//           { path: "security/roles-and-permissions/create", element: <RoleAndPermissionForm /> },
//           { path: "security/roles-and-permissions/:id/edit"  , element: <RoleAndPermissionForm /> },
//           // { path: "roles-and-permissions", element: <RolesAndPermissions /> },
//           { path: "security/roles-and-permissions", element: <RoleListPage /> },
//           { path: "security/roles-and-permissions/create", element: <RoleAndPermissionForm /> },
//           { path: "security/roles-and-permissions/:id/edit"  , element: <RoleAndPermissionForm /> },
//           // { path: "roles-and-permissions", element: <RolesAndPermissions /> },

//           // Audit Logs
//           { path: "security/audit-logs", element: <UpgradeRequired /> },

//           // Settings
//           { path: "security/settings/password-policy", element: <UpgradeRequired /> },
//           { path: "security/settings/2fa", element: <UpgradeRequired /> },

//           /* ===========================
//             REPORTS
//           =========================== */

//           // Dashboard
//           { path: "reports/dashboard", element: <ReportsPage /> },
//           { path: "reports/duplicate-clients", element: <DuplicateClients /> },

//           // Existing Reports
//           { path: "reports/daily-followup", element: <UserFollowupReport /> },
//           { path: "reports/client-stage", element: <ClientStageReport /> },
//           { path: "reports/onboarding-calendar", element: <ClientOnboardingCalendar /> },
//           { path: "reports/mis-report", element: <MISReport /> },

//           { path: "reports/sales-person/:userId", element: <SalesPersonReport /> },
//           { path: "reports/division/:divisionId", element: <DivisionDashboard /> },

//           // Sidebar Placeholder Reports
//           { path: "reports/sales", element: <UpgradeRequired /> },
//           { path: "reports/financial", element: <UpgradeRequired /> },
//           { path: "reports/hr", element: <UpgradeRequired /> },

//           // Settings
//           { path: "reports/settings/scheduled", element: <UpgradeRequired /> },

//           /* ===========================
//             COMMON
//           =========================== */

//           { path: "my-account", element: <MyAccount /> },

//           { path: "settings", element: <Settings /> },

//           /* ===========================
//             FINAL CATCH ALL
//           =========================== */

//           {
//             path: "*",
//             element: <UnderDevelopment />,
//           },
//         ],
//       },
//     ],
//   },
// ]);

// export default router;


//  // {
//       //   path : "/:portalName",
//       //   element: <Layout />,
//       //   children: [
//       //     { path: "home", element: <Home /> },
//       //     { path: "reports/sales-person/:userId", element: <SalesPersonReport /> },
//       //     { path: "reports/division/:divisionId", element: <DivisionDashboard /> },
//       //     { path: "my-account", element: <MyAccount /> },
//       //     { path: "my-organization", element: <MyOrganization /> },
//       //     { path: "ase-performance", element: <ClientVisits />, },
//       //     { path: "ase-performance/client-visits/create", element: <ClientVisitForm /> },
//       //     { path: "ase-performance/client-visits/edit/:id", element: <ClientVisitForm /> },
//       //     { path: "onboarding-clients", element: <OnboardingClients /> },
//       //     { path: "onboarding-clients/view/:clientId", element: <ViewClientOnboarding /> },
//       //     { path: "onboarding-clients/edit/:clientId", element: <EditOnboardingClient /> },
//       //     // { path: "client-visits", element: <ClientVisitList />, },
//       //     { path: "ase-performance/client-visits/view/:id", element: <ClientVisitDetail /> },
//       //     { path: "divisions", element: <Divisions />, },
//       //     { path: "departments", element: <Departments />, },
//       //     { path: "all-users", element: <AllUsers />, },
//       //     { path: "invitations", element: <InvitationPage />, },
//       //     { path:"invitations/invite", element: <InviteUserForm />},
//       //     { path: "roles-and-permissions", element: <RolesAndPermissions />, },
//       //     { path: "stages", element: <StageManagement />, },    
//       //     { path: "settings", element: <Settings />, },  
//       //     { path:"reports", element:<ReportsPage />},
//       //     { path: "reports/daily-followup", element: <UserFollowupReport />, },
//       //     { path: "reports/client-stage", element: <ClientStageReport />, },
//       //     // { path: "reports/client-map", element: <ClientMap />, },
//       //     { path: "reports/onboarding-calendar", element: <ClientOnboardingCalendar />, },
//       //     { path: "reports/mis-report", element: <MISReport />, },
          
//       //     // Catch-all route for undefined paths
//       //       {
//       //           path: "*",
//       //           element: <UnderDevelopment />
//       //       }
//       //   ],
//       // },


import React from "react";
import { createBrowserRouter } from "react-router-dom";
import App from "../App";
import Login from "../pages/Login";
import SignUp from "../pages/SignUp";
import ForgotPassword from "../pages/ForgotPassword";
import ResetPassword from "../pages/ResetPassword";
import Layout from "../components/Layout"; // Header + Sidebar + Outlet

import Settings from "../pages/Settings";
import UnAuthorize from "../pages/UnAuthorize";
import NotFound from "../pages/NotFound";

import UnderDevelopment from "../pages/UnderDevelopment";
import SalesDashboard from "../pages/Sales/SalesDashboard";
import Divisions from "../pages/Divisions";
import Departments from "../pages/Departments";
import MyOrganization from "../pages/MyOrganization";
import MyAccount from "../pages/MyAccount";
import AcceptInvitation from "../pages/AcceptInvitation";
import ClientVisits from "../pages/ClientVisits";
import ClientVisitForm from "../components/ClientVisitsComponents/ClientVisitForm";
import ClientVisitDetail from "../components/ClientVisitsComponents/ClientVisitDetail";
import StageManagement from "../pages/StageManagement";
import SalesPersonReport from "../pages/SalesPersonReport";
import DivisionDashboard from "../components/Dashboard/DivisionDashboard";
import AllUsers from "../pages/AllUsers";
import InvitationPage from "../pages/InvitationPage";
import InviteUserForm from "../components/InvitationComponent/InviteUserForm";
import UserFollowupReport from "../pages/Reports/UserFollowupReport";
import ReportsPage from "../pages/ReportsPage";
import MISReport from "../pages/Reports/MISReport";
import ClientStageReport from "../pages/Reports/ClientStageReport";
import OnboardingClients from "../pages/OnboardingClients";
import ViewClientOnboarding from "../components/OnboardingComponents/ViewClientOnboarding";
import ClientOnboardingCalendar from "../pages/Reports/ClientOnboardingCalendar";
import EditOnboardingClient from "../components/OnboardingComponents/EditOnboardingClient";
import UpgradeRequired from "../helpers/UpgradeRequired";
import ClientListing from "../pages/Sales/ClientListing";
import DuplicateClients from "../pages/Sales/DuplicateClients";
import CreateEditEmployeeForm from "../components/HRComponents/CreateEditEmployeeForm";
import ViewOneEmployee from "../components/HRComponents/ViewOneEmployee";
import RoleListPage from "../pages/Security/RoleListPage";
import RoleAndPermissionForm from "../components/SecurityComponents/RoleAndPermissionForm";
import SecurityUsers from "../pages/Security/SecurityUsers";
import UserPermissionOverrideForm from "../components/SecurityComponents/UserPermissionOverrideForm";
import EmployeeFinanceForm from "../components/HRComponents/EmployeeFinanceForm";
import DesignationList from "../pages/HR/DesignationList";
import SalaryGradesPage from "../pages/HR/Setting/SalaryGradesPage";
import ShiftManagement from "../pages/HR/Setting/ShiftManagement";
import { HolidayManagement } from "../pages/HR/Setting/HolidayManagement";
import { LeaveTypePage } from "../pages/HR/Setting/LeaveTypePage";
import HROverviewTabs from "../pages/HR/HROverviewTabs";
import OpenLeads from "../pages/OpenLeads";
import KRAReviewWorkflowManagement from "../pages/HR/Setting/KRAReviewWorkflowManagement";
import KraPerformanceTabs from "../pages/HR/KraPerformanceTabs";
import ReviewEvaluation from "../components/HRComponents/ReviewEvaluation";
import LeaveManagementTabs from "../pages/HR/LeaveManagementTabs";
import HRDetailedReportPage from "../components/HRComponents/Reports/HRDetailedReportPage";
import CaseCategoryList from "../pages/HR/Setting/CaseCategoryList";
import CaseTrackerTabs from "../pages/HR/CaseTrackerTabs";
import RecruitmentOverviewTabs from "../pages/HR/RecruitmentOverviewTabs";
import CandidateOfferRespond from "../components/HRComponents/CandidateOfferRespond";
import PushNotificationForm from "../pages/pushnotifications/PushNotificationForm";
import PushNotificationHistory from "../pages/pushnotifications/PushNotificationHistory";
import EmailWorkflows from "../pages/workflows/EmailWorkflow";
import WhatsAppWorkflows from "../pages/workflows/WhatsappWorkflow"
import WhatsAppWorkflowHistory from "../pages/workflows/WhatsAppWorkflowHistory";
import PolicyForm from "../components/HRComponents/PolicyForm";
import PolicyAssign from "../components/HRComponents/PolicyAssign";
import PolicyAcknowledgementReport from "../components/HRComponents/PolicyAcknowledgementReport";
import PolicyViewDetails from "../components/HRComponents/PolicyViewDetails";
import PolicyCategoryManager from "../components/HRComponents/PolicyCategoryManager";
import PolicyTabs from "../pages/HR/PolicyTabs";
import EmployeePolicyView from "../components/HRComponents/EmployeePolicyView";
import LMSCourseList from "../pages/HR/LMSCourseList";
import LMSCourseForm from "../components/HRComponents/LMS/LMSCourseForm";
import ExpoManagement from "../pages/ExpoManagement";
import ExpoLeadsList from "../pages/Sales/ExpoLeadsList";
import AssignLmsCourse from "../components/HRComponents/LMS/AssignLmsCourse";
import LeavePoliciesPage from "../components/HRComponents/LeavePoliciesPage";
import OurProductBusinessCategories from "../pages/Sales/OurProductBusinessCategories";
import OurProductList from "../pages/Sales/OurProductList";
import ProgramList from "../pages/Sales/settings/pages/ProgramList";
import ProgramForm from "../pages/Sales/settings/components/ProgramForm";
import ProgramView from "../pages/Sales/settings/components/ProgramView";
import BranchList from "../pages/Home/settings/pages/BranchList";
import BranchForm from "../pages/Home/settings/components/BranchForm";
import BranchView from "../pages/Home/settings/components/BranchView";
// import Projects from "../pages/PMS/Projects";
// import ProjectForm from "../components/ProjectComponents/ProjectForm";
// import ProjectDetail from '../pages/PMS/ProjectDetail';
// import Timesheets    from '../pages/PMS/Timesheets';
// import ProjectView from '../pages/PMS/ProjectView';


const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      {
        index: true,
        element: <Login />,
      },
      {
        path: "/login",
        element: <Login />,
      },
      {
        path: "/accept-invitation",
        element: <AcceptInvitation />,
      },
      {
        path: "/sign-up",
        element: <SignUp />,
      },
      {
        path : "/forgot-password",
        element : <ForgotPassword />,
      },
      {
        path : "/reset-password/:token",
        element: <ResetPassword />,
      },
      {
        path : "/careers/offers/:id",
        element: <CandidateOfferRespond />,
      },
      { 
        path: "un-authorized", 
        element: <UnAuthorize /> 
      },
      {
        path: "*",
        element: <NotFound />
      },
       
      {
        path: "/:portalName",
        element: <Layout />,
        children: [
          /* =======================================================================
            DASHBOARDS (புதிய மெயின் டேஷ்போர்டு ரவுட்டுகள்)
          ======================================================================= */
          { path: "dashboard/overview", element: <UpgradeRequired /> }, // Executive overview (Home-ஐப் பயன்படுத்துகிறது)
          { path: "dashboard/sales", element: <SalesDashboard /> },
          { path: "dashboard/hr", element: <UpgradeRequired /> },
          { path: "dashboard/finance", element: <UpgradeRequired /> },
          { path: "dashboard/it", element: <UpgradeRequired /> },

          /* =======================================================================
            HOME
          ======================================================================= */
          { path: "home", element: <HROverviewTabs /> },

          // Home Settings
          { path: "home/settings/my-organization", element: <MyOrganization /> },
          { path: "home/settings/divisions", element: <Divisions /> },
          { path: "home/settings/branches", element: <BranchList /> },
          { path: "home/settings/branches/create", element: <BranchForm /> },
          { path: "home/settings/branches/edit/:id", element: <BranchForm /> },
          { path: "home/settings/branches/view/:id", element: <BranchView /> },
          { path: "home/settings/departments", element: <Departments /> },
          { path: "home/settings/designations", element: <DesignationList /> },
          { path: "home/settings/designations/create", element: <DesignationList /> },
          { path: "home/settings/notifications", element: <UpgradeRequired /> },
          { path: "home/settings/widgets", element: <UpgradeRequired /> },
          /* =======================================================================
            SALES
          ======================================================================= */
          // Sales Internal Dashboard (புதியது)
          { path: "sales/dashboard", element: <SalesDashboard /> },

          // Clients
          { path: "sales/clients", element: <ClientListing /> },
          { path: "sales/open-leads", element: <OpenLeads /> },
          { path: "sales/expo-leads", element: <ExpoLeadsList /> },
          { path: "sales/leads/convert/:leadId", element: <ClientVisitForm /> },


          // Leads
          { path: "sales/leads", element: <ClientVisits /> },
          { path: "sales/leads/create", element: <ClientVisitForm /> },
          { path: "sales/leads/edit/:id", element: <ClientVisitForm /> },
          { path: "sales/leads/view/:id", element: <ClientVisitDetail /> },
          { path: "sales/leads/convert/:leadId", element: <ClientVisitForm /> },

          // Sales Orders
          { path: "sales/sales-orders", element: <OnboardingClients /> },
          { path: "sales/sales-orders/view/:clientId", element: <ViewClientOnboarding /> },
          { path: "sales/sales-orders/edit/:clientId", element: <EditOnboardingClient /> },

          // Opportunities
          { path: "sales/opportunities/pipeline-view", element: <UpgradeRequired /> },
          { path: "sales/opportunities/view-all", element: <UpgradeRequired /> },

          // Quotations & Rest
          { path: "sales/quotations", element: <UpgradeRequired /> },
          { path: "sales/sales-channels", element: <UpgradeRequired /> },
          { path: "sales/delivery-management", element: <UpgradeRequired /> },
          { path: "sales/invoices", element: <UpgradeRequired /> },
          { path: "sales/payments", element: <UpgradeRequired /> },
          { path: "sales/sales-returns", element: <UpgradeRequired /> },

          // Sales Settings
          { path: "sales/settings/pipeline-stages", element: <StageManagement /> },
          { path: "sales/settings/quotation-templates", element: <UpgradeRequired /> },
          { path: "sales/settings/tax-pricing", element: <UpgradeRequired /> },
          { path: "sales/settings/expo-management", element: <ExpoManagement /> },
          { path: "sales/settings/business-verticals", element: <OurProductList /> },
          { path: "sales/settings/business-categories", element: <OurProductBusinessCategories /> },
          { path: "sales/settings/programs", element: <ProgramList /> },
          { path: "sales/settings/programs/create", element: <ProgramForm /> },
          { path: "sales/settings/programs/edit/:id", element: <ProgramForm /> },
          { path: "sales/settings/programs/view/:id", element: <ProgramView /> },

          /* =======================================================================
            MARKETING
          ======================================================================= */
          { path: "marketing/dashboard", element: <UpgradeRequired /> }, // புதியது
          { path: "marketing/campaigns", element: <UpgradeRequired /> },
          { path: "marketing/promotions", element: <UpgradeRequired /> },
          { path: "marketing/audience", element: <UpgradeRequired /> },

          // Marketing Settings
          { path: "marketing/settings/email-templates", element: <UpgradeRequired /> },
          { path: "marketing/settings/integrations", element: <UpgradeRequired /> },

          /* =======================================================================
            FINANCE
          ======================================================================= */
          { path: "finance/dashboard", element: <UpgradeRequired /> }, // புதியது
          { path: "finance/accounts", element: <UpgradeRequired /> },
          { path: "finance/payments", element: <UpgradeRequired /> },
          { path: "finance/expenses", element: <UpgradeRequired /> },
          { path: "finance/taxation", element: <UpgradeRequired /> },

          // Finance Settings
          { path: "finance/settings/chart-of-accounts", element: <UpgradeRequired /> },
          { path: "finance/settings/currency-tax", element: <UpgradeRequired /> },

          /* =======================================================================
            INVENTORY
          ======================================================================= */
          { path: "inventory/dashboard", element: <UpgradeRequired /> }, // புதியது
          { path: "inventory/stock", element: <UpgradeRequired /> },
          { path: "inventory/purchase-orders", element: <UpgradeRequired /> },
          { path: "inventory/suppliers", element: <UpgradeRequired /> },

          // Inventory Settings
          { path: "inventory/settings/warehouses", element: <UpgradeRequired /> },
          { path: "inventory/settings/stock-alerts", element: <UpgradeRequired /> },

          /* =======================================================================
            LOGISTICS
          ======================================================================= */
          { path: "logistics/dashboard", element: <UpgradeRequired /> }, // புதியது
          { path: "logistics/shipments", element: <UpgradeRequired /> },
          { path: "logistics/delivery-tracking", element: <UpgradeRequired /> },
          { path: "logistics/vendors", element: <UpgradeRequired /> },

          // Logistics Settings
          { path: "logistics/settings/shipping-zones", element: <UpgradeRequired /> },
          { path: "logistics/settings/carrier-setup", element: <UpgradeRequired /> },

          /* =======================================================================
            SERVICES
          ======================================================================= */
          { path: "services/dashboard", element: <UpgradeRequired /> }, // புதியது
          { path: "services/requests", element: <UpgradeRequired /> },
          { path: "services/catalogue", element: <UpgradeRequired /> },

          // Services Settings
          { path: "services/settings/categories", element: <UpgradeRequired /> },
          { path: "services/settings/sla-rules", element: <UpgradeRequired /> },

          /* =======================================================================
            HR
          ======================================================================= */
          { path: "hr/dashboard", element: <UpgradeRequired /> }, // புதியது
          { path: "hr/employee-management", element: <AllUsers /> },
          { path: "hr/employee-management/employee-finance/:employeeId", element: <EmployeeFinanceForm /> },
          { path: "hr/employee-management/employee-create", element: <CreateEditEmployeeForm /> },
          { path: "hr/employee-management/employee/edit/:employeeId", element: <CreateEditEmployeeForm /> },
          { path: "hr/employee-management/employee-view/:employeeId", element: <ViewOneEmployee /> },
          

                    // ==== ADDED: Recruitment & Onboarding Routes ====
          { path: "hr/recruitment-management", element: <RecruitmentOverviewTabs /> },
          // { path: "hr/projects", element: <Projects /> },
          // { path: "hr/projects/create", element: <ProjectForm /> },
          // { path: "hr/projects/edit/:id", element: <ProjectForm /> },
          
          // // Project Dashboard (Workspace Console with Tabs) - Changed :id to :projectId
          // { path: "hr/projects/:projectId", element: <ProjectDetail /> },
          
          // // Project Overview View Page - Changed :id to :projectId
          // { path: "hr/projects/:projectId/view", element: <ProjectView /> },
          
          // { path: "hr/timesheets", element: <Timesheets /> },
          // { path: "hr/timesheets/my", element: <Timesheets /> },
          // Organization Structure
          { path: "hr/divisions", element: <Divisions /> },
          { path: "hr/departments", element: <Departments /> },

          { path: "hr/attendance-management", element: <HROverviewTabs /> },
          { path: "hr/leave-management", element: <LeaveManagementTabs /> },
          { path: "hr/payroll-management", element: <UpgradeRequired /> },
          { path: "hr/expense-management", element: <UpgradeRequired /> },
          { path: "hr/training-management", element: <UpgradeRequired /> },
          { path: "hr/document-management", element: <UpgradeRequired /> },
          { path: "hr/performance-management", element: <KraPerformanceTabs /> },
          { path: "hr/performance-management/reviews/evaluation/:id", element: <ReviewEvaluation /> },
          { path: "hr/letter-policy", element: <PolicyTabs /> },
          { path: "hr/letter-policy/category", element: <PolicyCategoryManager /> },
          { path: "hr/letter-policy/create", element: <PolicyForm /> },
          { path: "hr/letter-policy/edit/:id", element: <PolicyForm /> },
          { path: "hr/letter-policy/view/:id", element: <PolicyViewDetails /> },
          { path: "hr/letter-policy/assign/:id", element: <PolicyAssign /> },
          { path: "hr/letter-policy/acknowledgements/:id", element: <PolicyAcknowledgementReport /> },
          { path: "hr/letter-policy/my-policies/:id", element: <EmployeePolicyView /> },
          { path: "hr/case-tracker", element: <CaseTrackerTabs /> },
          { path: "hr/exit-management", element: <UpgradeRequired /> },

          // HR LMS
          { path: "hr/lms-management/courses", element: <LMSCourseList /> },
          { path: "hr/lms-management/courses/create", element: <LMSCourseForm /> },
          { path: "hr/lms-management/courses/edit/:id", element: <LMSCourseForm mode="edit" /> },
          { path: "hr/lms-management/courses/view/:id", element: <LMSCourseForm mode="view" /> },
          { path: "hr/lms-management/courses/assign/create", element: <AssignLmsCourse mode="create" /> },


          // HR Settings
          { path: "hr/settings/shifts", element: <ShiftManagement /> },
          { path: "hr/settings/holidays", element: <HolidayManagement /> },
          { path: "hr/settings/leave-types", element: <LeaveTypePage /> },
          { path: "hr/settings/leave-policies", element: <LeavePoliciesPage /> },
          { path: "hr/settings/kra/review/workflows", element: <KRAReviewWorkflowManagement /> },
          { path: "hr/settings/case-category", element: <CaseCategoryList /> },
          { path: "hr/settings/payroll-setup", element: <SalaryGradesPage /> },

          /* =======================================================================
            IT
          ======================================================================= */
          { path: "it/dashboard", element: <UpgradeRequired /> },
          { path: "it/assets", element: <UpgradeRequired /> },
          { path: "it/tickets", element: <UpgradeRequired /> },
          { path: "it/access-management", element: <UpgradeRequired /> },

          // IT Settings
          { path: "it/settings/asset-categories", element: <UpgradeRequired /> },
          { path: "it/settings/ticket-priorities", element: <UpgradeRequired /> },

          /* =======================================================================
            LEGAL
          ======================================================================= */
          { path: "legal/dashboard", element: <UpgradeRequired /> }, // புதியது
          { path: "legal/contracts", element: <UpgradeRequired /> },
          { path: "legal/compliance", element: <UpgradeRequired /> },

          // Legal Settings
          { path: "legal/settings/contract-templates", element: <UpgradeRequired /> },

          /* =======================================================================
            SECURITY
          ======================================================================= */
          { path: "security/dashboard", element: <UpgradeRequired /> }, // புதியது
          { path: "security/users", element: <SecurityUsers /> },
          { path: "security/users/permissions/edit/:userId", element: <UserPermissionOverrideForm /> },

          // Invitations
          { path: "security/invitations", element: <InvitationPage /> },
          { path: "security/invitations/invite", element: <InviteUserForm /> },

          // Roles
          { path: "security/roles-and-permissions", element: <RoleListPage /> },
          { path: "security/roles-and-permissions/create", element: <RoleAndPermissionForm /> },
          { path: "security/roles-and-permissions/:id/edit"  , element: <RoleAndPermissionForm /> },

          // Audit Logs & Settings
          { path: "security/audit-logs", element: <UpgradeRequired /> },
          { path: "security/settings/password-policy", element: <UpgradeRequired /> },
          { path: "security/settings/2fa", element: <UpgradeRequired /> },

          /* =======================================================================
            REPORTS & EXISTING REPORT DASHBOARDS
          ======================================================================= */
          { path: "reports/dashboard", element: <ReportsPage /> },
          { path: "reports/duplicate-clients", element: <DuplicateClients /> },
          { path: "reports/daily-followup", element: <UserFollowupReport /> },
          { path: "reports/client-stage", element: <ClientStageReport /> },
          { path: "reports/onboarding-calendar", element: <ClientOnboardingCalendar /> },
          { path: "reports/mis-report", element: <MISReport /> },

          { path: "reports/sales-person/:userId", element: <SalesPersonReport /> },
          { path: "reports/division/:divisionId", element: <DivisionDashboard /> },

          // Sidebar Placeholder Reports
          { path: "reports/sales", element: <UpgradeRequired /> },
          { path: "reports/financial", element: <UpgradeRequired /> },
          { path: "reports/hr", element: <HRDetailedReportPage /> },

          // Reports Settings
          { path: "reports/settings/scheduled", element: <UpgradeRequired /> },

          /* =======================================================================
            COMMON & MISC
          ======================================================================= */
          { path: "my-account", element: <MyAccount /> },
          { path: "settings", element: <Settings /> },

           // automation settings
          {path:"automation/push-notifications",element:<PushNotificationForm/>},
          {path:"automation/notification-history",element:<PushNotificationHistory/>},
           {path:"automation/email-workflows",element:<EmailWorkflows/>},
           {path:"automation/whatsapp-workflows",element:<WhatsAppWorkflows/>},
           {path:"automation/whatsapp-workflows",element:<WhatsAppWorkflowHistory/>},

          /* =======================================================================
            FINAL CATCH ALL FOR SUB-PATHS
          ======================================================================= */
          {
            path: "*",
            element: <UnderDevelopment />,
          },
        ],
      },
    ],
  },
]);

export default router;